import { defaultStartTimeList } from '../const';

export const getMainSendRequestParams = ({
  auth,
  method = "read",
}) => {
  const isStandaloneMode = !auth.orgs || Object.keys(auth.orgs).length === 0;
  const apiBaseUrl = isStandaloneMode ? `/orgs/:orgId` : `/ents/:entId/orgs/:orgId`;
  const apiUrl = `${apiBaseUrl}/sites/:siteId/settings/radio.${method}`;

  const requestParamsConfig = {
    standalone: {
      orgId: auth.realm?.id,
      siteId: auth.sites?.id,
    },
    nonStandalone: {
      entId: auth.realm?.id,
      orgId: auth.realm?.id,
      siteId: auth.sites?.id,
    },
  };

  const requestParams = isStandaloneMode ? requestParamsConfig["standalone"] : requestParamsConfig["nonStandalone"];

  return {
    apiUrl,
    requestParams
  };
}

export const getInitData = ({
  responseData
}) => {
  return {
    ...responseData
  }
}

export const getInitStartTimeList = ({
  radioData
}) => {
  const schedule = radioData?.["wireless.radioGlobal"]?.neighborApDetectionSchedule ?? [];
  return defaultStartTimeList.map((item) => ({
    ...item,
    isSelected: schedule.includes(item.value),
  }));
}

export const getCleanPayload = ({
  radioData,
}) => {

  const payload = {
    data: {
      ...radioData,
    }
  };

  return payload;
}

export const getIsFormInvalid = ({
  radioData
}) => {
  let isInvalid = false;

  if(radioData?.["wireless.radioGlobal"]?.neighborApDetection){
    if(!radioData["wireless.radioGlobal"]?.neighborApDetectionSchedule?.length) isInvalid = true;
  }

  return isInvalid;
}